import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { TableCell } from "~/components/TableView/TableCell";
import { rightAlignedTableCells } from "~/components/TableView/types";
import { ConfigVisibilityToggleType, getVisibilityToggleTypeFromString } from "~/constants/configViews";
import { TABLE_ROW_CELL } from "~/constants/testIDs";
import { configViewOptionsSelector } from "~/store/configViews/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
import { makeActiveTableColumnFromOption } from "../tableColumnWidthsUtils";
import { useTableView } from "../TableViewContext";
export const ConfigurableTableCells = /*#__PURE__*/ memo((param)=>{
    let { rowInfo, renderCustomFieldTableCellComponent, actorAvatar } = param;
    const configViewOptions = useAirSelector(configViewOptionsSelector);
    const { getColumnWidthStyle } = useTableView();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: configViewOptions.map((option)=>{
            if (option.isCustomField && option.customFieldId && option.isVisible) {
                return renderCustomFieldTableCellComponent(option);
            }
            const toggleType = getVisibilityToggleTypeFromString(option.fieldName);
            if (!toggleType || !option.isVisible) {
                return null;
            }
            const tableCellProps = {
                ["data-testid"]: "".concat(TABLE_ROW_CELL, "-").concat(option.fieldName),
                style: getColumnWidthStyle(makeActiveTableColumnFromOption(option.fieldName, option.isCustomField, option.customFieldId)),
                // !important added here to override padding set in `DesktopTableRowContainer`
                className: rightAlignedTableCells.has(toggleType) ? "text-right !pr-4" : "text-left"
            };
            const cellValue = rowInfo[toggleType];
            if (toggleType === ConfigVisibilityToggleType.uploadedBy) {
                return /*#__PURE__*/ _jsx(TableCell, {
                    ...tableCellProps,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "flex w-full items-center gap-2",
                        children: [
                            actorAvatar,
                            /*#__PURE__*/ _jsx("span", {
                                className: "truncate",
                                children: cellValue
                            })
                        ]
                    })
                }, option.fieldName);
            }
            return /*#__PURE__*/ _jsx(TableCell, {
                ...tableCellProps,
                children: cellValue
            }, option.fieldName);
        })
    });
});
ConfigurableTableCells.displayName = "ConfigurableTableRows";
